import { createTheme } from "@mui/material";

// use this the change the theme
const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          padding: "5px",
          boxShadow: "1px 1px 1px 1px #cccccc",
          '& .MuiDataGrid-row:nth-of-type(odd)': {
            backgroundColor: "#f4f4f4ff",
            '&:hover':{
              backgroundColor: "#e9e7e7",
            }
          },
          p:{
            margin:0 // overrides bootstrap
          }
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          
          color: '#6693F',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          // Your custom styles for Tooltip
          backgroundColor: 'your_desired_background_color',
        },
      },
    },
  },
});

export default theme;
